module.exports = "<div *ngIf=\"chartBlock\" [chart]=\"chartBlock\" style=\"height:220px;\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/components/report-quality-graph/report-quality-graph.component.html
// module id = ./src/app/view/components/report-quality-graph/report-quality-graph.component.html
// module chunks = main